import axios from 'axios';
import config from "../../config/index";

// Function to generate relevant context using OpenAI
export const generateToolContext = async (sampleQuestion, sampleOutput, availableKeys, apiData,selectedtimezone) => {
  try {
    
    // Process available keys - maximum 6 keys
    const limitedKeys = availableKeys.slice(0, 6);
    console.log('Limited Keys (max 6):', limitedKeys,selectedtimezone);
    
    // Extract sample data for the keys (maximum 6 entries)
    let sampleData = {};
    if (apiData && typeof apiData === 'object') {
      let dataArray = [];
      
      // Convert apiData to array format
      if (Array.isArray(apiData)) {
        dataArray = apiData.slice(0, 6);
      } else if (apiData.data && Array.isArray(apiData.data)) {
        dataArray = apiData.data.slice(0, 6);
      } else if (typeof apiData === 'object') {
        dataArray = [apiData];
      }
      
      // Extract sample values for each key
      limitedKeys.forEach(key => {
        const sampleValues = dataArray.map(item => item[key]).filter(val => val !== undefined);
        if (sampleValues.length > 0) {
          sampleData[key] = sampleValues.slice(0, 3); // Max 3 sample values per key
        }
      });
    }
    
    // Create the prompt
    const currentTime = new Date().toISOString();
    const prompt = `You are a smart scheduling assistant. Generate instructions based on the following structure and fields.

        Follow this exact structure:

        CURRENT TIME  
        - Consider current time according to timezone ${selectedtimezone} <Add this line to the prompt without any explanation and change.>
        - These are {{CURRENTDATE}}  {{CURRENTDATETIME}}  {{CURRENTTIME}} dynamic variables for current date and time  If any variable is used in the prompt.These variables will be replaced with the actual values at runtime.

        DATA FIELDS  
        - "<field1>": <description>  
        - "<field2>": <description>  
        ...  
        - Ignore: <comma-separated fields to ignore>

        INSTRUCTIONS  
        1. Rule 1  
        2. Rule 2  
        ...  
        N. Rule N  
        N+1. Format: [field]: YYYY-MM-DD HH:MM to HH:MM  
        N+2. Response must be under 10 words.  
        N+3. Do not mention timezones or any explanation.  
        N+4. Follow the structure exactly — no deviation.

        Now, generate the full prompt using the following values:

        - Current Time: ${new Date().toISOString()}  
        - Fields: ${JSON.stringify(limitedKeys)}  
        - Sample Data: ${JSON.stringify(sampleData, null, 2)}  
        - Sample Question: ${sampleQuestion}  
        - Sample Output: ${sampleOutput}

        Your response must follow the original example format, but adapt it based on these fields and values.
        `;

    console.log('Generated Prompt:', prompt);
    console.log('=== End Debug Info ===');

    // FIX: Use the generated prompt
    const response = await axios.post(`${config.apiBaseURL2}generate-prompt`, {
      prompt: prompt
    });

    if (response.data) {
      return {
        success: true,
        context: response?.data?.output[0]?.content[0]?.text,
        usage: response.data.usage
      };
    } else {
      console.error("Error:", response.data);
      return {
        success: false,
        error: response.data.error
      };
    }
  } catch (error) {
    console.error("Exception in generateToolContext:", error);
    return {
      success: false,
      error: error.message
    };
  }
};

